import Request from "../lib/request";
import {CITIES_API, LOCATION_API, PROVINCES_API} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const getProvince = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${LOCATION_API}/${PROVINCES_API}`,
    needToken: true
  });
};

export const getCity = (id) => {
  return Request({
    method: "get",
    url: `${baseUrl}/${LOCATION_API}/${id}/${CITIES_API}`,
    needToken: true
  });
};
